<app-card [type]="3" [title]="'feature.song.edit' | translate">
  <app-song-edit-card
    cardBody3
    [songUploadData]="songUploadData"
    [song]="songUploadData.song"
    (submitEvent)="onSubmit()"
    (uploadSuccessEvent)="onUploadSuccess()"
  ></app-song-edit-card>
</app-card>
